export * from '@uifabric/foundation';
//# sourceMappingURL=Foundation.js.map